import { DateTime, Info } from 'luxon';

export const offsetDateTime = (
	date: DateTime | Date | string,
	timeZoneName: string,
): DateTime => {
	if (Info.isValidIANAZone(timeZoneName) === false) {
		throw new Error(`timezone ${timeZoneName} is not valid`);
	}
	const dateToUse =
		typeof date === 'object' && 'toJSDate' in date
			? date.toJSDate()
			: new Date(date);

	return DateTime.fromJSDate(dateToUse).setZone(timeZoneName);
};
